var _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFillCupper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 983,
    height: 1024,
    viewBox: "0 0 983 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M786.649 737.378v65.102c0 17.359-13.021 34.718-34.722 34.718s-34.722-13.017-34.722-34.718v-65.102c0-56.422-43.401-95.486-95.482-95.486h-260.409c-56.422 0-95.483 43.401-95.483 95.486v65.102c0 17.359-13.020 34.718-34.721 34.718s-34.721-13.017-34.721-34.718v-65.102c0-91.144 69.442-164.925 164.925-164.925h260.409c91.14 4.338 164.925 73.781 164.925 164.925z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M491.516 511.689c91.083 0 164.925-73.839 164.925-164.924s-73.843-164.925-164.925-164.925c-91.086 0-164.926 73.839-164.926 164.925s73.839 164.924 164.926 164.924z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFillCupper);
export default __webpack_public_path__ + "static/media/icon-fill-cupper.c1342207ddc6a3745d030bdd3db85690.svg";
export { ForwardRef as ReactComponent };